import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NewUserBackButton from '../components/NewUserBackButton';

// eslint-disable-next-line no-shadow
function VerifyIncome() {
  const store = useSelector(state => ({
    shopify: state.technical?.shopify,
    checkoutLookupData: state.personal?.checkoutLookupData,
    newUserDetails: state.personal?.newUserDetails,
    error: state.technical?.error,
  }));
  const history = useHistory();

  const goFurtherToReview = () => {
    history.push('/new-user-review');
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <h1 className="congratulation-header">Verify your income</h1>
        <p className="k-not-approved-text">It looks like you entered your income as</p>
        <p>
          <span className="k-verify-income-number">${store.newUserDetails.income}</span>
          <span> per-year</span>
        </p>
        <p className="k-not-approved-text">Is that correct?</p>
        <div className="k-verify-income">
          <NewUserBackButton text="No, change it" />
          <div className="k-submit k-error-button k-not-approved-button">
            <button type="button" onClick={goFurtherToReview}>
              <strong>Yes</strong>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default VerifyIncome;
